import React, {Fragment, useState} from "react";
import closeIcon from "../../../../assets/svg/actions/icn-close.svg";
import ModalBase from "../../modals/ModalBase";
import {Button, Card, Form} from "react-bootstrap";
import SVG from "react-inlinesvg";
import Icon from "../../Icon";
import "../../../../assets/sass/components/messages/attachment-file-modal.scss";
import pdfSVG from "../../../../assets/svg/ils/ils-file-pdf.svg";
import defaultSVG from "../../../../assets/svg/ils/ils-file.svg";


class AttachmentFileModal extends ModalBase {

    state = {
        show: this.props.show,
        message: '',
    }

    setImageTemplete = (attachment) => {
        return (
            <div className="attachment-image">
                <img src={attachment.base64} alt={attachment.name}/>
                <span>{attachment.name}</span>
            </div>
        )
    }

    setTemplete = (attachment) => {
        var extention = attachment.type ? attachment.type.match(/\/.+/g,"")[0].slice(1) : "";
        return (
            <Card className="attachment">
                <Icon svg={extention == "pdf" ? pdfSVG : defaultSVG } alt={attachment.name}/>
                <span>{attachment.name}</span>
            </Card>
        )
    }

    setTempleteFile = (attachment) => {
        if(attachment) {
            var type = attachment.type ? attachment.type.replace(/\/.+/g,"") : "";
            switch (type) {
                case "application": {
                    return this.setTemplete(attachment);
                }; break;
                case "image": {
                    return this.setImageTemplete(attachment);
                }; break;
                default: {
                    return this.setTemplete(attachment);
                }; break;
            }
        }
    }

    onSubmit = (event) => {
        event.preventDefault();
        var { onAttachmentSubmit } = this.props;
        if(onAttachmentSubmit) {
            onAttachmentSubmit(event, this.state.message);
        }
        this.setState({
            message: ''
        })
    }

    onInput = (event) => {
        this.setState({
            message: event.target.value
        })
    }

    renderBody = () => {
        return (
            <Form onSubmit={this.onSubmit}>
                <div className="d-flex justify-content-between align-items-center">
                    <h2>Attachment</h2>
                    <Button variant="link" className="close-modal" onClick={this.closeModal}>
                        <SVG src={closeIcon}/>
                    </Button>
                </div>

                <p>Add caption or message with the file, If any</p>

                <textarea name="message" placeholder="Type your message here" className="input input-flat input-lg" value={this.state.message} onInput={this.onInput}></textarea>

                {this.setTempleteFile(this.props.attachment)}

                <Button type="submit" variant="primary" className="btn-lg btn-block">Send File</Button>
            </Form>
        )
    };

    renderHeaderWrapper = () => {
    }
    renderFooterWrapper = () => {
    }

    static defaultProps = {
        className: "attachment-file-modal",
        size: "md"
    };
};

export default AttachmentFileModal;